import { AxiosBaseApi } from '@config/axios.config'
import { ENDPOINTS } from '@constants'
import { AxiosResponse } from 'axios'

export class JobsApi extends AxiosBaseApi {
  /* SINGLE ENTITIES */
  get_job_single = (id: number | string) =>
    this.api
      .get<AxiosResponse<any>>(ENDPOINTS.SYSTEM.JOB_SINGLE(id))
      .then(response => response.data?.data)

  get_job_batch_single = (id: number | string) =>
    this.api
      .get<AxiosResponse<any>>(ENDPOINTS.SYSTEM.JOB_BATCH_SINGLE(id))
      .then(response => response.data?.data)

  get_failed_job_single = (id: number | string) =>
    this.api
      .get<AxiosResponse<any>>(ENDPOINTS.SYSTEM.FAILED_JOB_SINGLE(id))
      .then(response => response.data?.data)

  /* ACTIONS */
  retry_failed_job = (id: number | string) =>
    this.api
      .post<AxiosResponse<any>>(ENDPOINTS.SYSTEM.FAILED_JOB_RETRY(id))
      .then(response => (response.data?.data ?? response.data))
}
